import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { INotification } from '../interfaces/notification';

@Injectable()
export class NotifyService {

  private _note = new Subject<INotification>();

  note$ = this._note.asObservable();

  constructor() { }

  setNote(note: INotification): void {
    this._note.next(note);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/notify.service.ts